function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "nwfia",
  d: "M713 54.5c-.6.833-1.333 1.6-2.133 2.4-.8.8-1.566 1.566-2.4 2.133-2.766 1.967-5.467 2.6-6.634 1.433l-1.066-1.066c-.267-.3.133-1.133.9-1.9.767-.767 1.633-1.167 1.9-.9l.966.966-.067-.066c.667.667 1.966.466 3.368-.333.6-.368 1.2-.9 1.767-1.466.566-.567 1.066-1.1 1.433-1.701.867-1.434 1.067-2.767.4-3.434l.066.067-.966-.966c-.267-.267.133-1.133.9-1.9.767-.767 1.633-1.167 1.9-.9l1.066 1.067c1.2 1.132.534 3.799-1.4 6.566zM708 39c-8.267 0-15 6.733-15 15s6.733 15 15 15 15-6.733 15-15-6.733-15-15-15z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-693 -39)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#2e2c47",
  xlinkHref: "#nwfia"
})));

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-icon.a0c2b6e8.svg";
export { ForwardRef as ReactComponent };